import type { DictationFieldProfile } from './dictation.types'

export function normalizeTranscript(input: string): string {
	return input.replace(/\s+/g, ' ').trim()
}

function ensureSentenceCase(text: string): string {
	if (!text) return text
	const trimmed = text.trim()
	const capped = trimmed.charAt(0).toUpperCase() + trimmed.slice(1)
	return /[.!?]$/.test(capped) ? capped : `${capped}.`
}

function toBullets(text: string): string {
	const chunks = text
		.split(/\n|(?<=[.!?])\s+/)
		.map((chunk) => chunk.trim())
		.filter(Boolean)
	if (chunks.length <= 1) {
		return `- ${chunks[0] ?? text.trim()}`
	}
	return chunks.map((chunk) => `- ${chunk.replace(/^-\s*/, '')}`).join('\n')
}

export function applyFormattingProfile(input: string, profile: DictationFieldProfile): string {
	const normalized = normalizeTranscript(input)
	if (!normalized) return ''
	return profile === 'bullets' ? toBullets(normalized) : ensureSentenceCase(normalized)
}

export function appendTranscriptValue(currentValue: string, chunk: string, profile: DictationFieldProfile): string {
	const formatted = applyFormattingProfile(chunk, profile)
	if (!formatted) return currentValue
	if (!currentValue.trim()) return formatted
	const separator = profile === 'bullets' ? '\n' : ' '
	return `${currentValue}${separator}${formatted}`.trim()
}
